import { Base } from '@gate31/core/src/libs/BaseComponent';
import { CardModalForm } from '@gate31/feature/CardModalForm/CardModalForm';
import { ModalOpts } from '@gate31/feature/Modal/Modal';
import { LiquidTemplates } from '@gate31/uikit/common/scripts/liquid-render';

export class CardModalFormDesk extends CardModalForm {
    static cn = new Base.BuildCn('CardModalFormDesk');

    constructor(options: { template: keyof LiquidTemplates; modalTemplate: ModalOpts['template']; whenOpenModal: (product: unknown) => void}) {
        super({
            template: options.template,
            modalTemplate: options.modalTemplate,
            cn: CardModalFormDesk.cn,
            whenOpenModal: options.whenOpenModal
        });
    }
}
